import React from "react";

const NCDDashboardV2 = () => {
  // 🧪 Dummy realistic data
  const data = {
    population: 15000,
    screened: 12000,
    diagnosed: 3200,
    treated: 2100,
    followUp: 1500,
    tobacco: 28,
    bmi: 32,
    mortality: 2.4,
  };

  // 📊 Derived
  const screeningCoverage = ((data.screened / data.population) * 100).toFixed(1);
  const detectionRate = ((data.diagnosed / data.screened) * 100).toFixed(1);
  const treatmentRate = ((data.treated / data.diagnosed) * 100).toFixed(1);
  const followUpRate = ((data.followUp / data.treated) * 100).toFixed(1);

  const treatmentGap = data.diagnosed - data.treated;

  return (
    <div className="bg-gray-100 min-h-screen font-sans">

      {/* 🟦 HEADER */}
      <div className="bg-white border-b px-6 py-4 flex justify-between items-center">
        <div>
          <h1 className="text-xl font-semibold text-gray-800">
            NCD Health Monitoring Portal
          </h1>
          <p className="text-xs text-gray-500">
            Government of Health Department
          </p>
        </div>

        <div className="text-sm text-gray-600">
          District: Mumbai | Date: Today
        </div>
      </div>

      {/* 🟥 ALERT STRIP */}
      <div className="px-6 py-3 space-y-2">
        {treatmentRate < 70 && (
          <div className="bg-red-100 border border-red-300 text-red-800 px-4 py-2 text-sm">
            ⚠ Low treatment coverage ({treatmentRate}%) — immediate attention required
          </div>
        )}

        {followUpRate < 70 && (
          <div className="bg-yellow-100 border border-yellow-300 text-yellow-800 px-4 py-2 text-sm">
            ⚠ Follow-up compliance is low ({followUpRate}%)
          </div>
        )}
      </div>

      {/* 🟨 MAIN GRID */}
      <div className="px-6 grid md:grid-cols-2 gap-6">

        {/* ▣ Screening */}
        <div className="bg-white border p-4">
          <h2 className="font-semibold text-gray-700 mb-3">
            Screening Coverage
          </h2>

          <p className="text-2xl font-bold text-gray-800">
            {screeningCoverage}%
          </p>

          <p className="text-sm text-gray-600 mt-1">
            {data.screened} individuals screened out of {data.population}
          </p>

          {screeningCoverage < 80 && (
            <p className="text-red-600 text-sm mt-2">
              Coverage below target — expand outreach
            </p>
          )}
        </div>

        {/* ▣ Detection & Treatment */}
        <div className="bg-white border p-4">
          <h2 className="font-semibold text-gray-700 mb-3">
            Detection & Treatment
          </h2>

          <p className="text-sm">Diagnosed: {data.diagnosed}</p>
          <p className="text-sm">Under Treatment: {data.treated}</p>

          <p className="text-sm mt-2">
            Treatment Coverage: <b>{treatmentRate}%</b>
          </p>

          <p className="text-red-600 text-sm mt-2">
            {treatmentGap} patients not on treatment
          </p>
        </div>

        {/* ▣ Patient Journey */}
        <div className="bg-white border p-4">
          <h2 className="font-semibold text-gray-700 mb-3">
            Patient Journey
          </h2>

          <div className="space-y-2 text-sm">
            <p>Screened: {data.screened}</p>
            <p>Diagnosed: {data.diagnosed}</p>
            <p>Treated: {data.treated}</p>
            <p>Follow-up: {data.followUp}</p>
          </div>

          <p className="text-red-600 text-sm mt-2">
            Drop-off observed after diagnosis
          </p>
        </div>

        {/* ▣ Outcomes & Risk */}
        <div className="bg-white border p-4">
          <h2 className="font-semibold text-gray-700 mb-3">
            Outcomes & Risk Indicators
          </h2>

          <p className="text-sm">Tobacco Use: {data.tobacco}%</p>
          <p className="text-sm">BMI ≥25: {data.bmi}%</p>
          <p className="text-sm">Mortality: {data.mortality}%</p>

          {data.mortality > 2 && (
            <p className="text-red-600 text-sm mt-2">
              High mortality rate — needs investigation
            </p>
          )}
        </div>

      </div>

      {/* 🟩 ACTION PANEL */}
      <div className="px-6 mt-6 pb-6">
        <div className="bg-white border p-4">
          <h2 className="font-semibold text-gray-700 mb-3">
            Recommended Actions
          </h2>

          <ul className="list-disc pl-5 text-sm space-y-1">
            <li>Increase treatment enrollment for diagnosed patients</li>
            <li>Strengthen follow-up tracking system</li>
            <li>Improve screening coverage in low-performing areas</li>
          </ul>
        </div>
      </div>

    </div>
  );
};

export default NCDDashboardV2;